import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIENDPOINTS } from '../common/constants';
import { APPLICATION_REGISTER_MODEL } from '../core/models/application-register.model';
import { CreditOffer } from '../core/models/CreditOffer';
import { Contact } from '../core/models/contact.model';
import { ApiService } from '../core/services/api.service';
import { ConfigService } from '../core/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class CreditofferService {
  creditDetails: APPLICATION_REGISTER_MODEL;
  pAddress: any;
  cAddress: any;
  offerConfirmationNumber: string;
  offerHeaderDetails: any = null;
  primaryContact: Contact = null;
  secondaryContact: Contact = null;
  constructor(private apiService: ApiService, private configService: ConfigService) { }

  public save(creditOffer: any): any {
    
    return this.apiService.saveUsingOptions<CreditOffer>(this.configService.OfferUrl, creditOffer, {responseType:'text'});
  }

  public update(offerId:number, authoriserNam: any): any {

    return this.apiService.update<CreditOffer>(APIENDPOINTS.offerDeclaration + offerId, authoriserNam);
  }

  uploadFile(fileContent: any, requestId:string): Observable<any> {
    return this.apiService.upload(
      this.configService.OfferFileUrl, fileContent, false, requestId);
  }

  public saveLandholders(landholderDetails: any): any {
    return this.apiService.save<any>(APIENDPOINTS.Landholders, landholderDetails);
  }

  public getPrograms(SnapshotIds: any): any {
    return this.apiService.findByPost<any>(this.configService.ProgramsUrl, SnapshotIds);
  }

  public prepare(snapshotId:number,creditIds:any): any {
    return this.apiService.save<any>(this.configService.PrepareOfferUrl + snapshotId, creditIds); 
  }
}
